import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { DataTableDirective } from 'angular-datatables';
import { Journey } from './../../../models/journey';
declare const refreshSchedule: any;
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { Subject } from 'rxjs/Rx';

// import { Chart, Highcharts, StockChart } from 'angular-highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-synthesis',
  templateUrl: './synthesis.component.html',
  styleUrls: ['./synthesis.component.css']
})
export class SynthesisComponent implements OnInit, AfterViewInit, OnDestroy {

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
  };
  staticFilter: any;
  filterCounter: number;
  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;
  clients: any[];
  schools: any[];
  buses: any[];
  days: {};
  types: {};
  journeys: {};

  KpiPositionDefini: number;
  KpiPassagerAffected2Bus: number;
  KpijourneyCoveredPassengers: number;

  SelectedPassengers: any[];
  isResponsible = false;
  chartData = {
    categories: [],
    series: []
  };

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  dtOptions: {};//DataTables.Settings = {};
  dtRefUrl: any = '';
  dtTrigger: Subject<any> = new Subject();
  dtModalTitle: any;
  dtColumns: any;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: {};//Highcharts.Options;
  chartPosOptions: {};
  chartAffOptions: {};
  chartTrOptions: {};

  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };

  constructor(private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService) {
    this.filterCounter = 0;
    this.initClientSelect();
    this.days = {
      1: 'Lundi',
      2: 'Mardi',
      3: 'Mercredi',
      4: 'Jeudi',
      5: 'Vendredi'
    };
    this.types = {
      M1: 'Matin (Aller)',
      M2: 'Matin (Retour)',
      AM1: 'Après-midi (Aller)',
      AM2: 'Après-midi (Retour)',
    };
    this.journeys = {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
    };
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit() {
    this.loadDatatables();
    this.loadHighChartsOptions();
    this.loadchartPositionOptions();
    this.loadchartAffectationOptions();
    this.loadchartTrajetOptions();
  }

  onKPIPosPassgerChange() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.dtRefUrl = '/api/planificationAndOptimization/synthesis/NotDefinedPosPassengers';
      this.loadDatatables();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
      this.selectViewDtModel('ShowModalPosition');
    });
  }

  onKPIAffBusChange(){
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.dtRefUrl = '/api/planificationAndOptimization/synthesis/NotAffectedPassengers';
      this.loadDatatables();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
      this.selectViewDtModel('ShowModalAffectation');
    });
  }

  onKPITrBusChange() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.dtRefUrl = '/api/planificationAndOptimization/synthesis/uncoveredPassengers';
      this.loadDatatables();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
      this.selectViewDtModel('ShowModalTraject');
    });
  }

  selectViewDtModel(view: string): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
    switch (view) {
      case 'ShowModalPosition':
        this.dtModalTitle = 'Les passagers avec position non defini';
        if (this.roleService.getRole('ROLE_ADMIN')) {
          dtInstance.column(0).visible(true, false);
          dtInstance.column(1).visible(true, false);
          dtInstance.column(2).visible(true, false);
          dtInstance.column(3).visible(true, false);
          dtInstance.column(4).visible(true, false);
          dtInstance.column(5).visible(false, false);
          dtInstance.column(6).visible(true, false);
          dtInstance.column(7).visible(false, false);
          dtInstance.column(8).visible(true, false);
          dtInstance.column(9).visible(true, false);
          dtInstance.column(10).visible(true, false);
        } else {
          dtInstance.column(0).visible(true, false);
          dtInstance.column(1).visible(true, false);
          dtInstance.column(2).visible(true, false);
          dtInstance.column(3).visible(true, false);
          dtInstance.column(4).visible(false, false);
          dtInstance.column(5).visible(true, false);
          dtInstance.column(6).visible(false, false);
          dtInstance.column(7).visible(true, false);
          dtInstance.column(8).visible(true, false);
          dtInstance.column(9).visible(true, false);
        }
      break;
      case 'ShowModalAffectation':
        this.dtModalTitle = 'Les passagers non affectés à un bus';
        if (this.roleService.getRole('ROLE_ADMIN')) {
          dtInstance.column(0).visible(true, false);
          dtInstance.column(1).visible(true, false);
          dtInstance.column(2).visible(false, false);
          dtInstance.column(3).visible(true, false);
          dtInstance.column(4).visible(true, false);
          dtInstance.column(5).visible(true, false);
          dtInstance.column(6).visible(false, false);
          dtInstance.column(7).visible(false, false);
          dtInstance.column(8).visible(false, false);
          dtInstance.column(9).visible(false, false);
          dtInstance.column(10).visible(false, false);
        } else {
          dtInstance.column(0).visible(true, false);
          dtInstance.column(1).visible(false, false);
          dtInstance.column(2).visible(true, false);
          dtInstance.column(3).visible(true, false);
          dtInstance.column(4).visible(true, false);
          dtInstance.column(5).visible(false, false);
          dtInstance.column(6).visible(false, false);
          dtInstance.column(7).visible(false, false);
          dtInstance.column(8).visible(false, false);
          dtInstance.column(9).visible(false, false);
        }
      break;
      case 'ShowModalTraject':
        this.dtModalTitle = 'Les passagers non affectés à un trajet';
        if (this.roleService.getRole('ROLE_ADMIN')) {
          dtInstance.column(0).visible(true, false);
          dtInstance.column(1).visible(true, false);
          dtInstance.column(2).visible(true, false);
          dtInstance.column(3).visible(true, false);
          dtInstance.column(4).visible(true, false);
          dtInstance.column(5).visible(true, false);
          dtInstance.column(6).visible(false, false);
          dtInstance.column(7).visible(true, false);
          dtInstance.column(8).visible(false, false);
          dtInstance.column(9).visible(false, false);
          dtInstance.column(10).visible(false, false);
        } else {
          dtInstance.column(0).visible(true, false);
          dtInstance.column(1).visible(true, false);
          dtInstance.column(2).visible(true, false);
          dtInstance.column(3).visible(true, false);
          dtInstance.column(4).visible(true, false);
          dtInstance.column(5).visible(false, false);
          dtInstance.column(6).visible(true, false);
          dtInstance.column(7).visible(false, false);
          dtInstance.column(8).visible(false, false);
          dtInstance.column(9).visible(false, false);
        }
        break;
      }
      (dtInstance.columns as any).adjust().draw( false );
    });
  }


  ngAfterViewInit() {
    refreshSchedule();
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
     // Do not forget to unsubscribe the event
     this.dtTrigger.unsubscribe();
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        this.clientsData = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
        if (clients && clients.length) {
          this.filter.clientId = clients[0].id;
        }
        this.initSchoolSelect();
      });
    }
    this.staticFilter = this.filter;
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  loadchartPositionOptions() {

    this.chartPosOptions = {
        chart: {
          type: 'solidgauge'
      },

      title: null,

      pane: {
          center: ['50%', '55%'],
          // size: '100%',
          startAngle: -140,
          endAngle: 140,
          background: {
              backgroundColor:
                  Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
              innerRadius: '60%',
              outerRadius: '100%',
              shape: 'arc'
          }
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        stops: [
                [0.1, '#DF5353'], // red
                [0.5, '#DDDF0D'], // yellow
                [0.9, '#55BF3B'] // green
          ],
          lineWidth: 0,
          tickWidth: 0,
          minorTickInterval: null,
          className: 'highcharts-gauge-heading',
          tickAmount: 2,
          title: {
            text:
              '<div style="text-align:center">' +
              '<span style="font-size:14px;opacity:0.8">POSITIONS PASSAGER</span>' +
              '</div>',
            y: -68
          },
          labels: {
              x: -5,
              y: 50
          }
      },

      credits: {
        enabled: false
    },

      series: [{
          name: 'Position defini',
          data: [this.KpiPositionDefini],
          dataLabels: {
            format:
                '<div style="text-align:center">' +
                '<span style="font-size:25px">{y}%</span><br/>' +
                '<span style="font-size:12px;opacity:0.4">Positions defini</span>' +
                '</div>'
          }
      //   tooltip: {
      //       valueSuffix: ' Positions defini'
      //   }
      }],

      tooltip: {
        enabled: false
      },

      plotOptions: {
        solidgauge: {
            dataLabels: {
                y: -30,
                borderWidth: 0,
                useHTML: true
              }
          }
      },

      responsive: {
        rules: [{
          condition: {
            maxWidth: 300
          },
          chartOptions: {
            yAxis: {
              className: 'highcharts-gauge-heading-small'
            }
          }
        }]
      }
    };
  }

  loadchartAffectationOptions() {

    this.chartAffOptions = {
        chart: {
          type: 'solidgauge'
      },

      title: null,

      pane: {
          center: ['50%', '55%'],
          // size: '100%',
          startAngle: -140,
          endAngle: 140,
          background: {
              backgroundColor:
                  Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
              innerRadius: '60%',
              outerRadius: '100%',
              shape: 'arc'
          }
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        stops: [
                [0.1, '#bfdbf6'],
                [0.5, '#7cb5ec'],
                [0.9, '#398fe2']
          ],
          lineWidth: 0,
          tickWidth: 0,
          minorTickInterval: null,
          className: 'highcharts-gauge-heading',
          tickAmount: 2,
          title: {
            text:
                '<div style="text-align:center">' +
                '<span style="font-size:14px;opacity:0.8">AFFECTATION AU BUS</span>' +
                '</div>',
              y: -68
          },
          labels: {
              x: -5,
              y: 50
          }
      },

      credits: {
        enabled: false
    },

      series: [{
          name: 'Passagers affecté',
          data: [this.KpiPassagerAffected2Bus],
          dataLabels: {
            format:
                '<div style="text-align:center">' +
                '<span style="font-size:25px">{y}%</span><br/>' +
                '<span style="font-size:12px;opacity:0.4">Passagers affecté</span>' +
                '</div>'
          }
      //   tooltip: {
      //       valueSuffix: ' Positions defini'
      //   }
      }],

      tooltip: {
        enabled: false
      },

      plotOptions: {
        solidgauge: {
            dataLabels: {
                y: -30,
                borderWidth: 0,
                useHTML: true
              }
          }
      },

      responsive: {
        rules: [{
          condition: {
            maxWidth: 300
          },
          chartOptions: {
            yAxis: {
              className: 'highcharts-gauge-heading-small'
            }
          }
        }]
      }
    };
  }

  loadchartTrajetOptions() {

    this.chartTrOptions = {
        chart: {
          type: 'solidgauge'
      },

      title: null,

      pane: {
          center: ['50%', '55%'],
          // size: '100%',
          startAngle: -140,
          endAngle: 140,
          background: {
              backgroundColor:
                  Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
              innerRadius: '60%',
              outerRadius: '100%',
              shape: 'arc'
          }
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        stops: [
              [0.1, '#686870'],
              [0.5, '#434348'],
              [0.9, '#1e1e20']
          ],
          lineWidth: 0,
          tickWidth: 0,
          minorTickInterval: null,
          className: 'highcharts-gauge-heading',
          tickAmount: 2,
          title: {
            text:
              '<div style="text-align:center">' +
              '<span style="font-size:14px;opacity:0.8">AFFECTATION AU TRAJETS</span>' +
              '</div>',
            y: -68
          },
          labels: {
              x: -5,
              y: 50
          }
      },

      credits: {
        enabled: false
    },

      series: [{
          name: 'Couverture Trajet',
          data: [this.KpijourneyCoveredPassengers],
          dataLabels: {
            format:
                '<div style="text-align:center">' +
                '<span style="font-size:25px">{y}%</span><br/>' +
                '<span style="font-size:12px;opacity:0.4">Passagers couverts</span>' +
                '</div>'
          }
      //   tooltip: {
      //       valueSuffix: ' Positions defini'
      //   }
      }],

      tooltip: {
        enabled: false
      },

      plotOptions: {
        solidgauge: {
            dataLabels: {
                y: -30,
                borderWidth: 0,
                useHTML: true
              }
          }
      },

      responsive: {
        rules: [{
          condition: {
            maxWidth: 300
          },
          chartOptions: {
            yAxis: {
              className: 'highcharts-gauge-heading-small'
            }
          }
        }]
      }
    };
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.schoolsData = this.schools.map((school, index) => {
        return { id: school.id, text: school.name };
      });
      if (schools && schools.length) {
        this.filter.schoolId = schools[0].id;
      }
      if (!this.filterCounter) {
        this.onFilter();
      }
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
  }

  initBusSelect() {
    this.staticFilter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      this.busesData = this.buses.map((bus, index) => {
        return { id: bus.id, text: bus.name };
      });
      if (buses && buses.length) {
        this.filter.busId = buses[0].id;
      }
    });
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
    this.loadBusSchedule();
  }

  loadDatatables() {
    let columns: any ;
    if (this.roleService.getRole('ROLE_ADMIN')) {
      columns = [
        { title: 'Client' , data: 'clientName' },
        { title: 'École' , data: 'busSchoolName' },
        { title: 'Bus' , data: 'busName' },
        { title: 'Nom' , data: 'lastname' },
        { title: 'Prénoms' , data: 'firstnames' },
        { title: 'Nbr passagers' , data: 'count' },
        { title: 'Tél' , data: 'phone' },
        { title: 'Abonnement' , data: 'subscription' },
        { title: "Position d'arrêt" , data: 'positionStatus' },
        { title: "Clés d'activation" , data: 'activationKey' },
        { title: 'SMS' , data: 'SmsToSend' },
      ];
    } else {
      columns = [
        { title: 'École' , data: 'busSchoolName' },
        { title: 'Bus' , data: 'busName' },
        { title: 'Nom' , data: 'lastname' },
        { title: 'Prénoms' , data: 'firstnames' },
        { title: 'Nbr passagers' , data: 'count' },
        { title: 'Tél' , data: 'phone' },
        { title: 'Abonnement' , data: 'subscription' },
        { title: "Position d'arrêt" , data: 'positionStatus' },
        { title: "Clés d'activation" , data: 'activationKey' },
        { title: 'SMS' , data: 'SmsToSend' },
      ];
    }

    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.filter;
        this.http.post<DataTablesResponse>(
          this.dtRefUrl,
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          // console.log(resp.data);


          this.SelectedPassengers = resp.data;
          let dta = [];
          this.SelectedPassengers.forEach((passenger, index) => {
            dta.push({
              id: passenger.id,
              busSchoolName: passenger.School.name,
              busName: (passenger.Bus) ? passenger.Bus.name : '',
              lastname: passenger.lastname,
              firstnames: passenger.firstnames,
              count: passenger.count,
              phone: passenger.phone,
              subscription: passenger.subscription,
              positionStatus: (passenger.isPositionValide ? `<label style="color:green">Définie</label>`
              : `<label style="color:red">Non définie</label>`),
              activationKey: passenger.activationKey,
              SmsToSend: passenger.SmsToSend == 0 ? `<label style="color:green">Envoyé</label>`
              : `<label style="color:orange">En-cours</label>`,
            });
            if (this.roleService.getRole('ROLE_ADMIN')) {
              dta[index].clientName = passenger.School.Client.name;
            }
          });

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'passenger_' + aData.id);
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
  }

  loadHighChartsOptions() {
    this.chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      colors: ['#f16e00'],
      xAxis: {
        title: {
          text: 'Liste des bus'
        },
        // labels: {
        //   formatter: function () {
        //     return '<strong> bus ' + this.value + '</strong>';
        //   }
        // },
        categories: this.chartData.categories,
        lineWidth: 2,
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Nombre de passagers',
        },
        // labels: {
        //   formatter: function () {
        //     return this.value;
        //   }
        // },
      },
      tooltip: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return this.y;
            },
          },
        },
      },
      series: [
        {
          name: '',
          data: this.chartData.series,
          // type: 'column'
        }
      ]
    };
  }

  loadBusSchedule() {
    this.journeys = {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
    };
    this.http.get(
      '/api/journey/bus/' + this.filter.busId,
    ).subscribe((journeys: Journey[]) => {
      $('.cd-schedule__events .cd-schedule__group ul').css('opacity', 0);
      journeys.forEach(journey => {
        // this.journeys[journey.day].push(journey);
        if (journey.J_1 == true) {
          this.journeys[1].push(journey);
        }

        if (journey.J_2 == true) {
          this.journeys[2].push(journey);
        }

        if (journey.J_3 == true) {
          this.journeys[3].push(journey);
        }

        if (journey.J_4 == true) {
          this.journeys[4].push(journey);
        }

        if (journey.J_5 == true) {
          this.journeys[5].push(journey);
        }
      });
      setTimeout(function () {
        refreshSchedule();
        $('.cd-schedule__events .cd-schedule__group ul').css('opacity', 1);
      }, 250);
    });
  }

  onFilter() {
    this.filterCounter++;
    this.staticFilter = this.filter;
    this.chartData = {
      categories: [],
      series: []
    };
    let params = new HttpParams({
      fromObject: {
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/planificationAndOptimization/synthesis',
      { params }
    ).subscribe((data: any) => {
      this.KpiPositionDefini = data.KpiPositionDefini;
      this.KpiPassagerAffected2Bus = data.KpiPassagerAffected2Bus;
      this.KpijourneyCoveredPassengers = data.KpijourneyCoveredPassengers;
      data.busesPassengersCount.forEach((elt, idx) => {
        this.chartData.categories.push(elt['Bus.name']);
        this.chartData.series.push(parseInt(elt['passengersCount'])); // parseInt: convert to init before push
        console.log('Info :  ' + elt['Bus.name'] + ' ' + parseInt(elt['passengersCount']));
      });

      this.loadHighChartsOptions();
      this.loadchartPositionOptions();
      this.loadchartAffectationOptions();
      this.loadchartTrajetOptions();
    });
    this.initBusSelect();
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/planning-and-optimization/synthesis/synthesis.component.ts